import styled from "styled-components"
import {Row, Container} from 'styled-bootstrap-grid'

const ServicesWrapper = styled.div`
  background-color: ${({
    theme: {
      palette: { darkblue },
    },
  }) => darkblue};
  padding-top: ${({
    theme: {
      header: { mobile },
    },
  }) => mobile};
  min-height: calc(
    100vh -
      ${({
        theme: {
          footer: { mobile },
        },
      }) => mobile}
  );
  color: white;

  @media only screen and (min-width: 576px) {
    padding-top: ${({
      theme: {
        header: { desktop },
      },
    }) => desktop};
    min-height: calc(
      100vh -
        ${({
          theme: {
            footer: { desktop },
          },
        }) => desktop}
    );
  }
`

const ServicesContent = styled.div`
  padding: ${({
    theme: {
      content: {
        padding: { mobile },
      },
    },
  }) => mobile};
  padding-bottom: ${({
    theme: {
      footer: { mobile },
    },
  }) => mobile};
  padding-top: 6rem;

  @media only screen and (min-width: 576px) and (max-width: 767px) {
    padding: ${({
      theme: {
        content: {
          padding: { tablet },
        },
      },
    }) => tablet};
    padding-bottom: ${({
      theme: {
        footer: { mobile },
      },
    }) => mobile};
  }

  @media only screen and (min-width: 768px) {
    padding: ${({
      theme: {
        content: {
          padding: { tablet },
        },
      },
    }) => tablet};
    padding-top: 10rem;
    padding-bottom: ${({
      theme: {
        footer: { mobile },
      },
    }) => mobile};
  }

  @media only screen and (min-width: 1900px) {
    padding: ${({
      theme: {
        content: {
          padding: { desktop },
        },
      },
    }) => desktop};
    padding-top: 10rem;
    padding-bottom: ${({
      theme: {
        footer: { mobile },
      },
    }) => mobile};
  }
`

const Title = styled.h1`
  font-size: ${({
    theme: {
      font: { sizes },
    },
  }) => sizes.s108};
  font-weight: ${({
    theme: {
      font: { weights },
    },
  }) => weights.w100};
`

const Paragraph1 = styled.div`
  margin-top: 6.25rem;
  margin-bottom: 8rem;
  font-size: ${({
    theme: {
      font: { sizes },
    },
  }) => sizes.s42};
  font-weight: ${({
    theme: {
      font: { weights },
    },
  }) => weights.w100};

  @media only screen and (min-width: 576px) {
    margin-bottom: 16rem;
  }
`

const ServicesGraph = styled.img`
  max-width: 100%;
  max-height: 660px;
`

const Card = styled.div`
  margin-top: ${({ theme: { spacing } }) => spacing.s10};
  margin-bottom: ${({ theme: { spacing } }) => spacing.s20};

  @media only screen and (max-width: 575px) {
    text-align: center;
    margin-bottom: ${({ theme: { spacing } }) => spacing.s45};
  }
`

const CardTitle = styled.h2`
  font-size: ${({
    theme: {
      font: { sizes },
    },
  }) => sizes.s42};
  color: ${({ color }) => color};
  margin-bottom: ${({ theme: { spacing } }) => spacing.s10};
`

const CardContent = styled.div``

const CardLine = styled.div`
  padding: ${({ theme: { spacing } }) => spacing.s5} 0;
  font-size: ${({
    theme: {
      font: { sizes },
    },
  }) => sizes.s26};
`

const ServicesRow = styled(Row)`
  margin-top: ${({ theme: { spacing } }) => spacing.s50};

  @media only screen and (min-width: 576px) {
    margin-top: 6.25rem;
  }
`

const ParagraphsRow = styled(Row)`
  margin-top: ${({ theme: { spacing } }) => spacing.s50};

  @media only screen and (min-width: 576px) {
    margin-top: 0;
  }
`

const ParagraphContainer = styled(Container)`
  @media only screen and (min-width: 576px) and (max-width: 1023px) {
    margin-top: ${({ theme: { spacing } }) => spacing.s50};
  }
`

export {
  ParagraphContainer,
  ParagraphsRow,
  ServicesRow,
  CardLine,
  CardContent,
  CardTitle,
  Card,
  ServicesGraph,
  Paragraph1,
  Title,
  ServicesContent,
  ServicesWrapper,
}
